const loadScript = (url, id, callback) => {
  // Only add script to DOM if it doesn't already exist
  if (!document.querySelector(`script#${id}`)) {
    const script = document.createElement('script');

    if (script.readyState) {
      script.onreadystatechange = () => {
        if (
          script.readyState === 'loaded'
          || script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = () => callback();
    }

    script.src = url;
    script.id = id;
    document.getElementsByTagName('head')[0].appendChild(script);
  } else {
    callback();
  }
};

export default loadScript;
